import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconChevronLeft } from '@/app/components/icons/ui-actions/icon-chevron-left';
import { IconChevronRight } from '@/app/components/icons/ui-actions/icon-chevron-right';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface LineupGroupNavProps {
  groupLabel: string;
  canScrollPrevGroup: boolean;
  canScrollNextGroup: boolean;
  onScrollPrev: () => void;
  onScrollNext: () => void;
}
export function LineupGroupNav(t0) {
  const $ = _c(17);
  const {
    groupLabel,
    canScrollPrevGroup,
    canScrollNextGroup,
    onScrollPrev,
    onScrollNext
  } = t0;
  const t1 = !canScrollPrevGroup;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconChevronLeft />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "button-prev-group",
      track: "cv-home",
      section: "lineup",
      text: "prev_group"
    });
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onScrollPrev || $[3] !== t1) {
    t4 = <Button type="button" size="2xs" variant="tertiary" className="p-0 text-gray-900" disabled={t1} aria-label={"\u0E01\u0E25\u0E38\u0E48\u0E21\u0E23\u0E38\u0E48\u0E19\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32"} iconBefore={t2} onClick={onScrollPrev} {...t3} />;
    $[2] = onScrollPrev;
    $[3] = t1;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = createDataAttributes({
      test: "group-label"
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== groupLabel) {
    t6 = <span className="user-select-none font-noto-bold pointer-events-none text-gray-900" {...t5}>{groupLabel}</span>;
    $[6] = groupLabel;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = !canScrollNextGroup;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconChevronRight />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "button-next-group",
      track: "cv-home",
      section: "lineup",
      text: "next_group"
    });
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== onScrollNext || $[11] !== t7) {
    t10 = <Button type="button" size="2xs" variant="tertiary" className="p-0 text-gray-900" disabled={t7} aria-label={"\u0E01\u0E25\u0E38\u0E48\u0E21\u0E23\u0E38\u0E48\u0E19\u0E16\u0E31\u0E14\u0E44\u0E1B"} iconBefore={t8} onClick={onScrollNext} {...t9} />;
    $[10] = onScrollNext;
    $[11] = t7;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t6) {
    t11 = <div className="rounded-2xs inline-flex w-44 items-center justify-between gap-x-2 bg-white p-2">{t4}{t6}{t10}</div>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}